import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import helper from './utils/helper'
import api from './api'
import './plugins/vant.js'
import lscache from 'lscache'
import VueQriously from 'vue-qriously'

Vue.use(http)
Vue.use(api)
Vue.use(helper)
Vue.use(VueQriously)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user = lscache.get('uu')
    if (typeof user !== 'undefined' && !user) {
      user = JSON.parse(user)
    }
    if (user === null || user === 'undefined') {
      alert('未登录，跳转')
      // window.location.href = 'http://192.168.56.10:9912/'
    }
  }
  next()
})

router.afterEach((to, from) => {
  if (typeof to.meta.title !== 'undefined') {
    document.title = to.meta.title
  }
  if (window.location.href.indexOf('?#') < 0) {
    window.location.href = window.location.href.replace('#', '?#')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
